import { useState, useCallback } from 'react'
import { supabase } from '../lib/supabase'

export type BroadcastResult = {
  phone: string
  ok: boolean
  error?: string | null
  wamid?: string | null
}

export type Broadcast = {
  id: string
  message: string
  sent_at: string
  total: number
  sent_count: number
  failed_count: number
  results: BroadcastResult[]
}

export function useAdminBroadcasts() {
  const [broadcasts, setBroadcasts] = useState<Broadcast[]>([])
  const [loading, setLoading] = useState(false)

  const fetchBroadcasts = useCallback(async () => {
    setLoading(true)
    const { data } = await supabase
      .from('admin_whatsapp_broadcasts')
      .select('*')
      .order('sent_at', { ascending: false })
      .limit(50)
    setBroadcasts((data as Broadcast[]) ?? [])
    setLoading(false)
  }, [])

  return { broadcasts, loading, fetchBroadcasts }
}
